import { ContextualService } from 'src/app/modules/contextual/services/contextual.service';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { apiObjType, campaignCardType, CommonService } from 'src/app/services/common.service';
import { appConstants } from 'src/app/services/constants/app.constants';
import { ModalWrapperService } from 'src/app/ui-components/modal-wrapper/modal-wrapper.service';
import { TncComponent } from '../tnc/tnc.component';

@Component({
    selector:'app-poshvine-offer-card',
    templateUrl : './offer-card.component.html',
    styleUrls:['./offer-card.component.scss']
})
export class OfferCardComponent{
    @Input() withLogo =  false;
    @Input() showFullInfo =  false;
    @Input() cardData = {} as campaignCardType;
    @Output() closeAuthenticationEvent: Subject<any> = new Subject<any>();
    appConstants = appConstants;
    modalInstance: NgbModalRef = {} as NgbModalRef;
    labelMapper:any = {
      all:'All',
      unlocked:'Unlocked',
      missed:'Missed',
      locked:'Locked',
      claimed:'Claimed',
      results_awaited :'Result awaited'
    }
    constructor(
        private modalService: ModalWrapperService,
        private router: Router,
        private commonService: CommonService,
        private contextualService: ContextualService
    ){

    }
    closeModal() {
        this.closeAuthenticationEvent.next(true);
    }
    getIcon(){
        if (this.cardData?.benefitType)
            return this.appConstants.contexualCardBg[this.cardData.benefitType].bgIcon
        else
            return this.appConstants.contexualCardBg.cashbackPercent.bgIcon
    }
    openTncModal(event: any) {
        event.stopPropagation();
        this.modalInstance = this.modalService.open(TncComponent, 'tnc-modal');
        console.log(this.cardData);
        this.modalInstance.componentInstance.cardData = this.cardData;

        this.modalInstance.componentInstance.hideEvent.subscribe((res: any) => {
            if (res) {

                this.modalInstance.close();
            }
        })
    }

    campaignClickEvent(campaign: any) {
        if (campaign.benefitType === 'seeAll') {
            this.router.navigate(['contextual'])
        }
        else if (campaign.campaignType === 'cashback' || campaign.status == 'missed' || campaign.status == 'locked' ||
        campaign.status === 'results_awaited') {
            if(this.showFullInfo) return;
            this.openContexualModal(campaign)
        }
        else {
            let queryParams: apiObjType = {}
            if (campaign?.redeemable_options?.includes('MembershipRedemptionOption')) {
                queryParams['memberships'] = true;
            }
            if (campaign?.redeemable_options?.includes('GiftCardRedemptionOption')) {
                queryParams['giftcards'] = true;
            }
            if (campaign?.redeemable_options?.includes('OfferRedemptionOption')) {
                queryParams['offers'] = true;
            }
            if (campaign?.campaignType.includes('special-bundle')) {
                queryParams['specialbundle'] = true;
            }
            if (campaign?.campaignName) {
              queryParams['campaignName'] = campaign?.campaignName;
            }
            if(campaign?.campaignRedemptionType){
              queryParams['campaignRedemptionType'] = campaign?.campaignRedemptionType;
            }
            this.contextualService.campaignData = JSON.parse(JSON.stringify(campaign));
            if (this.commonService.performBinValidation(campaign?.valid_bins, campaign.id, queryParams)) {
                this.router.navigate(['contextual', 'list', campaign.id], { queryParams: queryParams });
            }
        }
    }

    openContexualModal(event: any) {
        this.modalInstance = this.modalService.open(OfferCardComponent, 'contexual-banner-modal flex align-center justify-center w100 h100');
        this.modalInstance.componentInstance.cardData = event;
        this.modalInstance.componentInstance.showFullInfo = true;
        this.modalInstance.componentInstance.closeAuthenticationEvent.subscribe((res: any) => {
            if (res) {
                this.modalInstance.close();
            }
        })

    }
    cancelModal(){
      this.closeAuthenticationEvent.next(true);
    }
    get label(){
      return (this.cardData.status ) ? this.labelMapper[this.cardData.status] : '';
    }
}
